"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gaggio-montano": {
    "2fdbd5a7": [{
      "hkey": "35390ad7",
      "slug": "gaggio-montano",
      "name": "Gaggio Montano",
      "primary": true,
      "skipSearch": false
    }],
    "affrico": [{
      "hkey": "35390ad7",
      "slug": "gaggio-montano",
      "name": "Gaggio Montano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "553ccd47": [{
      "hkey": "665a7181",
      "slug": "abetaia-bombiana",
      "name": "Abetaia-Bombiana",
      "primary": true,
      "skipSearch": false
    }],
    "bombiana": [{
      "hkey": "665a7181",
      "slug": "abetaia-bombiana",
      "name": "Abetaia-Bombiana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;